import { useTimeFormatted } from 'modules/core/hooks/useTimeFormatted'

export const useShiftTimeFormatted = () => {
  const formatTime = useTimeFormatted()

  return (startAt: string, endAt: string): string => {
    return `${formatTime(startAt)} - ${formatTime(endAt)}`
  }
}
